@import '../../../globals/main.scss';

pn-pex-pricefinder {
}

.pex-pricefinder-top {
  display: flex;
  align-items: center;
  pn-illustration {
    width: 5.5rem;
    height: 5.5rem;
    margin-right: 1.6rem;
  }
}

.pex-pricefinder-form {
  margin: 1.6rem 0 0 0;
  padding: 0;
  border: 0;
  fieldset {
    margin: 0;
    padding: 0;
    border: 0;
    & + fieldset {
      margin-top: 1.6rem;
    }
    > div {
      display: flex;
      align-items: center;
      gap: 1em;
      > * {
        flex-grow: 1;
        width: 100%;
      }
    }
  }
  pn-button {
    align-self: end;
    margin-left: auto;
  }
  .datepicker {
    display: inline-flex;
    flex-direction: column;
    label {
      margin-bottom: 0.4rem;
      color: $gray700;
      font-size: 0.875em;
      display: flex;
      justify-content: space-between;
      align-items: flex-end;
      cursor: pointer;
      transition: color 0.2s;
    }
    pn-date-picker {
      width: 100%;
    }
  }
}

.pex-pricefinder-response {
  margin-top: 2.4rem;
  text-align: center;
  font-size: 2.4em;
}
